import React, { useEffect, useRef, useState } from "react";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import { Trans } from "react-i18next";
import {
  Callout,
  Tag,
  Spinner,
  H6,
  Card,
  Button,
  Slider,
  InputGroup,
  Popover,
  Label,
  Tooltip,
} from "@blueprintjs/core";
import i18n from "../../i18n";

import { Menu, MenuItem } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";

import {
  authenticatedGetFetch,
  authenticatedPostFetch,
  getBackendRoute,
} from "../../utils/AuthenticatedFetch";
import Gauge from "../Charts/Gauge";
import { parkLookup } from "../Structure/ParkSelector";

function CounterEditor(props) {
  const [value, edit] = useState(props.value);

  const [editingThreshold, editThreshold] = useState(false);
  const [startFull, setStartFull] = useState(props.startFull);
  const [endFull, setEndFull] = useState(props.endFull);
  const [max, setMax] = useState(props.endFull);

  return (
    <Popover
      placement="auto"
      interactionKind="click"
      trigger="focus"
      content={
        <Card>
          <H6>Modifier la valeur du compteur</H6>
          <InputGroup
            id="input_id"
            type="number"
            min={0}
            max={props.max}
            onChange={(ti) => edit(ti.target.valueAsNumber)}
            value={value}
          />
          <Slider
            value={value}
            min={0}
            max={props.max}
            stepSize={1}
            labelStepSize={
              props.max <= 100
                ? 10
                : props.max <= 600
                ? 100
                : props.max < 1900
                ? 200
                : 500
            }
            onChange={(ti) => edit(ti)}
          />

          {editingThreshold && (
            <div>
              <Tooltip
                content={
                  <p>
                    <Trans>counter_end_full_help</Trans>
                  </p>
                }
              >
                <Label>
                  <Trans>counter_end_full</Trans>
                  <InputGroup
                    inline={true}
                    id="input_id"
                    type="number"
                    min={0}
                    max={props.startFull}
                    onChange={(ti) => setEndFull(ti.target.valueAsNumber)}
                    value={endFull}
                  />
                </Label>
              </Tooltip>

              <Tooltip
                content={
                  <p>
                    <Trans>counter_start_full_help</Trans>
                  </p>
                }
              >
                <Label>
                  <Trans>counter_start_full</Trans>
                  <InputGroup
                    inline={true}
                    id="input_id"
                    type="number"
                    min={endFull}
                    max={props.max}
                    onChange={(ti) => setStartFull(ti.target.valueAsNumber)}
                    value={startFull}
                  />
                </Label>
              </Tooltip>

              <Tooltip
                content={
                  <p>
                    <Trans>counter_max_help</Trans>
                  </p>
                }
              >
                <Label>
                  <Trans>counter_max</Trans>
                  <InputGroup
                    inline={true}
                    id="input_id"
                    type="number"
                    min={endFull}
                    max={10000}
                    onChange={(ti) => setMax(ti.target.valueAsNumber)}
                    value={max}
                  />
                </Label>
              </Tooltip>
            </div>
          )}

          <Button
            icon="send-message"
            onClick={() =>
              authenticatedPostFetch(
                "/counter",
                {
                  srv: props.server,
                  id: props.id,
                  value: value,
                  name: props.name,
                  max: editingThreshold ? max : undefined,
                  startFull: editingThreshold ? startFull : undefined,
                  endFull: editingThreshold ? endFull : undefined,
                },
                () => edit(value)
              )
            }
          >
            <Trans>send</Trans>
          </Button>
          <Button icon="cog" onClick={() => editThreshold(!editingThreshold)} />
        </Card>
      }
    >
      <Button icon="edit" />
    </Popover>
  );
}

export function Counter(props) {
  const [counter, setCounter] = useState(undefined);
  let client = useRef(null);
  useEffect(() => {
    if (props.standalone === true) {
      authenticatedGetFetch(
        "/ws/supervision/counter?serverId=" +
          props.serverId +
          "&id=" +
          props.id,
        (response) => {
          setCounter(response);
          client.current = new W3CWebSocket(
            getBackendRoute("WS") +
              "/supervision/counter?serverId=" +
              props.serverId +
              "&id=" +
              props.id,
            ["Bearer", localStorage.getItem("token")]
          );

          client.current.onmessage = (message) => {
            try {
              const parsedmsg = JSON.parse(message.data);
              setCounter(parsedmsg);
            } catch (e) {
              console.error("counter ko from ws", message, e);
            }
          };
        }
      );
      return () => {
        if (client.current) {
          console.log("close");
          client.current.close();
        }
      };
    }
  }, []);

  return (
    <Card className="myCard">
      <div className="flexbox-center-large">
        <H6>
          {props.name?.charAt(0).toUpperCase() +
            props.name?.slice(1).toLowerCase()}
        </H6>
        {(props.editable === undefined || props.editable) && (
          <CounterEditor {...props} />
        )}
      </div>
      <div>
        <Gauge
          data={[
            counter?.value || props.value,
            counter?.endFull || props.endFull,
            counter?.max || props.max,
          ]}
          title={"cnt"}
        />
        <div className="flexbox-center">
          <Tag intent="primary">
            <b>{counter?.value || props.value}</b> <Trans>occupied</Trans>
          </Tag>
          <br />
          <Tag intent="success">
            <b>
              {(counter?.max || props.max) - (counter?.value || props.value)}
            </b>{" "}
            <Trans>available</Trans>
          </Tag>
        </div>
      </div>
    </Card>
  );
}

function CounterList(props) {
  const ret = Object.values(props.Counters).map((c) => (
    <Counter {...c} parkLookup={props.parkLookup[c["park"]]} />
  ));
  return <div className="flexbox-left">{ret}</div>;
}

export default class Counters extends React.Component {
  constructor(props) {
    if (props.counters)
      for (let counter in props.counters) {
        props.counters[counter].key =
          props.counters[counter].serverId + "_" + props.counters[counter].id;
      }
    super();
    this.state = {
      loaded: false,
      counters: props.counters ?? {},
      unauthorized: false,
      parkLookup: parkLookup(),
    };
  }

  handleCounterMessage(message) {
    try {
      const parsedmsg = JSON.parse(message.data);

      if (
        parsedmsg.id !== undefined &&
        parsedmsg.name !== undefined &&
        parsedmsg.max !== undefined &&
        parsedmsg.startFull !== undefined &&
        parsedmsg.endFull !== undefined &&
        parsedmsg.park !== undefined &&
        parsedmsg.value !== undefined
      ) {
        var newState = Object.assign({}, this.state); // Clone the state obj in newState
        newState.counters[parsedmsg.key] = parsedmsg;
        this.setState(newState);
      }
    } catch (e) {
      console.error("cannot parse" + message.data, e);
    }
  }

  componentDidMount() {
    if (localStorage.getItem("perm_SPV") === "true") {
      if (!this.state.counters || this.state.counters.length === 0) {
        authenticatedGetFetch("/supervision/counters", (response) => {
          this.setState({
            loaded: true,
            counters: response.reduce((a, v) => ({ ...a, [v.key]: v }), {}),
          });
          this.client = new W3CWebSocket(
            getBackendRoute("WS") +
              "/supervision/counters" +
              (this.props.groupFilter !== undefined
                ? this.props.groupFilter
                : ""),
            ["Bearer", localStorage.getItem("token")]
          );
          this.client.onmessage = (message) =>
            this.handleCounterMessage(message);
        });
      } else {
        this.setState({ loaded: true });
        this.client = new W3CWebSocket(
          getBackendRoute("WS") +
            "/supervision/counters" +
            (this.props.groupFilter !== undefined
              ? this.props.groupFilter
              : ""),
          ["Bearer", localStorage.getItem("token")]
        );
        this.client.onmessage = (message) => this.handleCounterMessage(message);
      }
    } else {
      this.setState({ unauthorized: true });
    }
  }

  componentWillUnmount() {
    if (this.client !== undefined) this.client.close();
  }

  render() {
    if (this.state.unauthorized) {
      return (
        <Callout intent="warning">
          <Trans>you are not allowed to visualize element:</Trans>
          <Trans>counters</Trans>
          <br />
          <Trans></Trans>
          <Trans>
            for any change of your permissions please contact an administrator
          </Trans>
        </Callout>
      );
    } else if (!this.state.loaded) {
      return <Spinner />;
    } else {
      return (
        <Callout title={<Trans>counters</Trans>}>
          <CounterList
            Counters={this.state.counters}
            parkLookup={this.state.parkLookup || []}
          />
        </Callout>
      );
    }
  }
}

export class CountersSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      open: false,
      counters: [],
      unauthorized: false,
    };
  }

  componentDidMount() {
    if (localStorage.getItem("perm_SPV") === "true") {
      authenticatedGetFetch("/supervision/counters", (response) => {
        this.setState({ loaded: true, counters: response });
      });
    } else {
      this.setState({ unauthorized: true });
    }
  }

  getNotSelectedCounter() {
    if (this.props.valueSelected.findIndex !== undefined)
      return this.state.counters.filter((el) => {
        return this.props.valueSelected?.findIndex((vs) => el.id === vs.id) < 0;
      });
    else return this.state.counters;
  }

  render() {
    if (this.state.unauthorized) {
      return (
        <Callout intent="warning">
          <Trans>you are not allowed to visualize element:</Trans>
          <Trans>counters</Trans>
          <br />
          <Trans></Trans>
          <Trans>
            for any change of your permissions please contact an administrator
          </Trans>
        </Callout>
      );
    } else if (!this.state.loaded) {
      return <Spinner />;
    } else {
      if (this.state.open)
        return (
          <Select
            items={this.getNotSelectedCounter()}
            itemRenderer={(item, { select, modifiers }) => {
              return (
                <MenuItem
                  key={item.id}
                  label={`(parc: ${item.park}, srv: ${item.server})`}
                  text={`${item.name}`}
                  onClick={() => {
                    this.props.onSelect(item.id, item);
                    this.setState({ open: false });
                  }}
                  itemListRenderer={({
                    items,
                    itemsParentRef,
                    query,
                    renderItem,
                  }) => {
                    const renderedItems = items
                      .map(renderItem)
                      .filter(
                        (item) =>
                          item != null &&
                          item.props.text != null &&
                          item.props.text
                            .toUpperCase()
                            .includes(query.toUpperCase())
                      );
                    return (
                      <Menu ulRef={itemsParentRef}>
                        <MenuItem disabled={true} />
                        {renderedItems}
                      </Menu>
                    );
                  }}
                />
              );
            }}
            itemListRenderer={({
              items,
              itemsParentRef,
              query,
              renderItem,
            }) => {
              const renderedItems = items
                .map(renderItem)
                .filter(
                  (item) =>
                    item != null &&
                    item.props.text != null &&
                    item.props.text.toUpperCase().includes(query.toUpperCase())
                );
              return (
                <Menu ulRef={itemsParentRef}>
                  <MenuItem disabled={true} />
                  {renderedItems}
                </Menu>
              );
            }}
          >
            <Button
              text={i18n.t("select an counter to add")}
              rightIcon="double-caret-vertical"
            />
          </Select>
        );
      else
        return (
          <Button
            icon="add"
            text={this.props.label || ""}
            onClick={() => this.setState({ open: true })}
          />
        );
    }
  }
}
